import React, { FC } from 'react';

import { ACModal } from 'shared/components';

interface NotificationModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
  buttonText?: string;
}

export const NotificationModal: FC<NotificationModalProps> = ({
  open,
  onClose,
  title = 'Your quote has expired',
  content = 'Your quote has expired. Click below to view your updated quote.',
  buttonText = 'View quote',
}) => {
  return (
    <ACModal
      title={title}
      content={<div className="ta-tooltip-container">{content}</div>}
      showCloseButton={false}
      showDivider={true}
      open={open}
      onClose={onClose}
      buttonText={buttonText}
    />
  );
};
